module.exports = __webpack_public_path__ + "img/project-management-hero.91187889.jpg";